import { localeUrl } from '@marketplace/helpers/url.js'
import Vue from 'vue'

export default ({ app }, inject) => {
    Vue.prototype.localeUrl = localeUrl
}
